export default __webpack_public_path__ + "static/media/loryHTP.eb8a2b6a.png";